module.exports = __webpack_public_path__ + "img/资产化的监控运维.2b0527b9.png";